import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_WEB_BOARD,
  GET_WEB_BOARDS,
  GET_WEB_BOARDS_BY_FILTER,
  ADD_WEB_BOARD,
  UPDATE_WEB_BOARD,
  UPDATE_REPLY_TO_WEB_BOARD,
  UPDATE_WEB_BOARD_ALREADY_READ,
  UPDATE_WEB_BOARD_HIT_RATE,
  DELETE_WEB_BOARD,
} from '../../../../queries/modules/web-board/web-board';

export async function getWebBoards(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_WEB_BOARDS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setWebBoards', data.getWebBoards);
      context.commit('setSuccess', null);
      return data.getWebBoards
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getWebBoard(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_WEB_BOARD,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getWebBoard
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getWebBoardsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_WEB_BOARDS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setWebBoards', data.getWebBoardsByFilter);
      context.commit('setSuccess', null);
      return data.getWebBoardsByFilter
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addWebBoard(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_WEB_BOARD,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const webBoards = [...context.state.webBoards];
      webBoards.unshift(data.addWebBoard);
      context.commit('setWebBoards', webBoards);
      context.commit('setSuccess', newItemSuccess(data.addWebBoard.topic));

      return data.addWebBoard
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateWebBoard(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_WEB_BOARD,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.webBoards.findIndex(item => item.id === data.updateWebBoard.id);
      const webBoards = [
        ...context.state.webBoards.slice(0, index),
        data.updateWebBoard,
        ...context.state.webBoards.slice(index + 1)
      ];
      context.commit('setWebBoards', webBoards);
      context.commit('setSuccess', updateItemSuccess(data.updateWebBoard.topic));

      return data.updateWebBoard
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateReplyToWebBoard(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_REPLY_TO_WEB_BOARD,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.webBoards.findIndex(item => item.id === data.updateReplyToWebBoard.id);
      const webBoards = [
        ...context.state.webBoards.slice(0, index),
        data.updateReplyToWebBoard,
        ...context.state.webBoards.slice(index + 1)
      ];
      context.commit('setWebBoards', webBoards);
      context.commit('setSuccess', updateItemSuccess(data.updateReplyToWebBoard.topic));

      return data.updateReplyToWebBoard
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateWebBoardHitCount(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_WEB_BOARD_HIT_RATE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.webBoards.findIndex(item => item.id === data.updateWebBoardHitCount.id);
      const webBoards = [
        ...context.state.webBoards.slice(0, index),
        data.updateWebBoardHitCount,
        ...context.state.webBoards.slice(index + 1)
      ];
      context.commit('setWebBoards', webBoards);
      context.commit('setSuccess', updateItemSuccess(data.updateWebBoardHitCount.topic));

      return data.updateWebBoardHitCount
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateWebBoardAlreadyRead(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_WEB_BOARD_ALREADY_READ,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.webBoards.findIndex(item => item.id === data.updateWebBoardAlreadyRead.id);
      const webBoards = [
        ...context.state.webBoards.slice(0, index),
        data.updateWebBoardAlreadyRead,
        ...context.state.webBoards.slice(index + 1)
      ];
      context.commit('setWebBoards', webBoards);
      context.commit('setSuccess', updateItemSuccess(data.updateWebBoardAlreadyRead.topic));

      return data.updateWebBoardAlreadyRead
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteWebBoard(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_WEB_BOARD,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.webBoards.findIndex(item => item.id === data.deleteWebBoard.id);
      const webBoards = [
        ...context.state.webBoards.slice(0, index),
        ...context.state.webBoards.slice(index + 1)
      ];
      context.commit('setWebBoards', webBoards);
      context.commit('setSuccess', deleteItemSuccess(data.deleteWebBoard.topic));

      return data.deleteWebBoard
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

